import React, { useEffect, useState } from "react";
import { Tab, TabId, Tabs, TabsProps } from "@blueprintjs/core";
import { get, isEmpty } from "lodash";
import { ITabs, IModel, IResult, ITab, IMutators, IMetadata } from "components/Template/types";
import { evaluate } from "components/Template/action";
import { isInvalid } from "components/Template/utils";
import Validate from "components/Template/Validate";
import "./Tabs.scss";

export interface ITabsProps extends TabsProps {
  template: ITabs;
  model: IModel;
  result?: IResult;
  tabs: Array<{ tab: ITab; component: React.ReactElement<any, any> }>;
  mutators: IMutators;
  metadata: IMetadata;
}

const TabsLayout = (props: ITabsProps) => {
  const { template, model, result, mutators, metadata } = props;
  const { getValue, isHidden } = mutators;
  const defaultTabId = get(template, ["items", "0", "name"], "") as TabId;
  const [tabId, setTabId] = useState(defaultTabId);

  useEffect(() => {
    setTabId(template.items[0].name);
  }, [template]);

  if ((isHidden && isHidden(template.name)) || (template.hidden && evaluate(model, template.hidden, getValue))) {
    return null;
  }
  return (
    <Validate {...props}>
      <Tabs
        key={template.name}
        id={template.name}
        onChange={setTabId}
        selectedTabId={tabId}
        vertical={template.vertical}
        animate
      >
        {props.tabs.map(({ tab, component }) => (
          <Tab
            key={tab.name}
            id={tab.name}
            title={
              metadata.initializing || !isEmpty(metadata.initialLoading) ? (
                tab.label
              ) : isInvalid(tab, model, result, metadata) ? (
                <span className="title-fault">{tab.label}</span>
              ) : (
                tab.label
              )
            }
            panel={component}
          />
        ))}
        <Tabs.Expander />
      </Tabs>
    </Validate>
  );
};

export default TabsLayout;
